<template>
  <v-container>
    <v-toolbar>
      <v-menu :close-on-content-click="false" v-model="mStartDate" :nudge-right="40" transition="scale-transition"
        offset-y min-width="290px">
        <template v-slot:activator="{ attrs, on }">
          <v-text-field v-bind="attrs" v-on="on" v-model="dStart" label="开始日期" style="width:100px;" clearable dense solo
            prepend-icon="event" readonly></v-text-field>
        </template>
        <v-date-picker v-model="dStart" locale="zh-cn"></v-date-picker>
      </v-menu>
      <v-menu :close-on-content-click="false" v-model="mEndDate" :nudge-right="40" transition="scale-transition" offset-y
        min-width="290px">
        <template v-slot:activator="{ attrs, on }">
          <v-text-field v-bind="attrs" v-on="on" v-model="dEnd" style="width:100px;" label="结束日期" dense solo clearable
            prepend-icon="event" readonly></v-text-field>
        </template>
        <v-date-picker v-model="dEnd" locale="zh-cn"></v-date-picker>
      </v-menu>
      <v-text-field v-model="dev_no" label="设备号" dense solo clearable prepend-icon="fa-cog" style="width:50px;">
      </v-text-field>
      <v-text-field v-model="search_str" label="搜索" dense solo prepend-icon="search" clearable>
      </v-text-field>
      <v-checkbox label="已发货" v-model="sel_soed" style="width: 100px"></v-checkbox>
      <v-checkbox label="未发货" v-model="sel_unso" style="width: 100px"></v-checkbox>
      <v-btn @click="reload" small color="success"><v-icon>search</v-icon>搜索</v-btn>
      <v-btn @click="toexcel" small color="info" style="margin-left:10px;"><v-icon>list_alt</v-icon>导出xlsx</v-btn>
      <v-btn v-if="canSo" @click="StockOut" :disabled="canOut" small color="info"
        style="margin-left:10px;"><v-icon>all_out</v-icon>出库</v-btn>
      <v-dialog v-model="dlgEdit" max-width="900px">
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-if="canAddP" v-bind="attrs" v-on="on" color="primary" small class="mb-2" @click="addItem"
            style="margin-left:10px;">添加生产计划</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ dlgTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row class="row">
                <v-col cols="2" class="fld">
                  <span class="flds">生产类别</span>
                </v-col>
                <v-col cols="3">
                  <v-combobox :items="kinditems" v-model="edItem.kind" dense solo>
                  </v-combobox>
                </v-col>
                <v-col cols="2" class="fld">
                  <span class="flds">计划生产日期</span>
                </v-col>
                <v-col cols="2">
                  <v-menu :close-on-content-click="true" v-model="mDate" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ attrs, on }">
                      <v-text-field v-bind="attrs" v-on="on" v-model="edItem.pn_d" dense solo readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="edItem.pn_d" @input="dateChange()" locale="zh-cn"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2" class="fld">
                  <span class="flds">当日序号</span>
                </v-col>
                <v-col cols="1">
                  <v-text-field v-model="edItem.pd_no" dense solo></v-text-field>
                </v-col>
              </v-row>
              <v-row class="row">
                <v-col cols="2" class="fld">
                  <span class="flds">釜票</span>
                </v-col>
                <v-col cols="10">
                  <formula-sel ref="formulaSel" @change="pdChange"></formula-sel>
                </v-col>
              </v-row>
              <v-row class="row">
                <v-col cols="2" class="fld">
                  <span class="flds">批次号</span>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="edItem.batch_no" dense solo></v-text-field>
                </v-col>
              </v-row>
              <v-row class="row">
                <v-col cols="2" class="fld">
                  <span class="flds">计划生产釜数</span>
                </v-col>
                <v-col cols="1">
                  <v-text-field v-model="edItem.pn_num" @change="pdChange" dense solo></v-text-field>
                </v-col>
                <v-col cols="2" class="fld">
                  <span class="flds">起始釜号</span>
                </v-col>
                <v-col cols="1">
                  <v-text-field v-model="edItem.fm_no" @change="pdChange" dense solo></v-text-field>
                </v-col>
                <v-col cols="6">
                  <div style="font-size: 12px;">{{ intro }}</div>
                </v-col>
              </v-row>
              <v-row class="row">
                <v-col cols="2" class="fld">
                  <span class="flds">备注</span>
                </v-col>
                <v-col cols="10">
                  <v-text-field v-model="edItem.note" dense solo></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small text @click="cancel">取消</v-btn>
            <v-btn color="primary" small @click="save">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-toolbar>
    <v-data-table v-model="selected" :headers="headers" :items="produces" :server-items-length="pagination.totalItems"
      :loading="loading" show-select hide-default-footer class="elevation-1">
      <template v-slot:item.act="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn v-if="canAddP" v-bind="attrs" v-on="on" x-small icon @click="editItem(item)"
              color="success"><v-icon>edit</v-icon></v-btn>
          </template>
          <span>编辑</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn v-if="canActP" v-bind="attrs" v-on="on" x-small icon @click="editItemA(item)"
              color="info"><v-icon>settings</v-icon></v-btn>
          </template>
          <span>实际生产</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn v-if="canDelP" v-bind="attrs" v-on="on" x-small icon @click="deleItem(item)"
              color="error"><v-icon>delete</v-icon></v-btn>
          </template>
          <span>删除</span>
        </v-tooltip>
      </template>
      <template slot="no-data">
        没有数据
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
    </div>
    <v-dialog v-model="dlgAEdit" max-width="990px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dlgTitle }}</span>
        </v-card-title>
        <v-card-text>
          <produce-a ref="produceA"></produce-a>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text small @click="cancelA">取消</v-btn>
          <v-btn color="primary" small @click="saveA">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dlgStockOut" max-width="1024px">
      <v-card>
        <div style="text-align:center;padding:8px;font-size:12px;">
          <h3>上海齐申复合材料出库</h3>
          <v-layout>
            <v-flex style="text-align:right;">出库单号:{{ soData.soNo }}</v-flex>
          </v-layout>
          <v-layout>
            <v-flex style="text-align:left;">收货方:{{ soData.customer_name }}</v-flex>
            <v-flex style="text-align:right;">日期:{{ soData.date }}</v-flex>
          </v-layout>
          <v-layout>
            <v-flex style="text-align:left;">收货地址:{{ soData.customer_address }}</v-flex>
            <v-flex>收货联系人:{{ soData.customer_contact }}</v-flex>
            <v-flex style="text-align:right;">电话:{{ soData.customer_phone }}</v-flex>
          </v-layout>
        </div>
        <v-data-table :items="soItems" :headers="soHeaders" hide-default-footer class="elevation-2">
          <template v-slot:item.idx="{ item, index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.cages="props">
            <v-edit-dialog :return-value.sync="props.item.cages" large cancel-text="取消" save-text="确定"
              @save="saveSo('cages', props.item.pd_id)">
              {{ props.item.cages_s }}
              <template v-slot:input>
                <div close="mt-3 title">仓储笼号</div>
                <v-checkbox style="display:inline-block;" v-for="ii in props.item.cages" :key="ii" :label="ii" :value="ii"
                  v-model="props.item.cages_sel"></v-checkbox>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.weight="props">
            <v-edit-dialog :return-value.sync="props.item.weight" large cancel-text="取消" save-text="确定"
              @save="saveSo('weight', props.item.pd_id)">
              {{ parseFloat(props.item.weight).toFixed(2) }}
              <template v-slot:input>
                <div slot="input" close="mt-3 title">修改数量</div>
                <v-text-field v-model="props.item.weight" label="出库重量" single-line autofocus dense solo>
                </v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.pkg_num="props">
            <v-edit-dialog :return-value.sync="props.item.pkg_n" large cancel-text="取消" save-text="确定"
              @save="saveSo('pkg_n', props.item.pd_id)">
              {{ props.item.pkg_n }}
              <template v-slot:input>
                <div close="mt-3 title">修改箱数</div>
                <v-text-field v-model="props.item.pkg_n" label="箱数" single-line autofocus dense solo>
                </v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.note="props">
            <v-edit-dialog :return-value.sync="props.item.note" large cancel-text="取消" save-text="确定"
              @save="saveSo('note', props.item.pd_id)">
              {{ props.item.note }}
              <template v-slot:input>
                <div close="mt-3 title">修改备注</div>
                <v-text-field v-model="props.item.note" label="备注" single-line autofocus dense solo>
                </v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text @click="dlgStockOut = false">取消</v-btn>
          <v-btn color="success" small @click="doSo">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
.container {
  padding: 4px;
  max-width: 100%;
}

.soTitle {
  font-size: 25px;
  text-align: center;
  font-weight: bold;
}

.soSub {
  font-size: 14px;
}

.soCap {
  font-weight: bold;
}

#so {
  padding: 10px;
}
</style>

<script>
import FormulaSel from '@/views/components/FormulaSel'
import { getKindList, getProduceList, getProduceExcel, addProduce, modifyProduce, deleteProduce, maxNo } from '@/api/produce'
import { getNewNo, addStockOut } from '@/api/stockout'
import { Int2Date, Date2Str, Date2Int, WeekStr, Min2Str, MsgError } from '@/libs/util'
import ProduceA from '@/views/components/ProduceA'
import { baseURLAPI, TOKEN_KEY } from '@/config'
import Cookies from 'js-cookie'
import Vue from 'vue'
import { canDo } from '@/libs/tools'

export default {
  components: {
    FormulaSel,
    ProduceA
  },
  data: () => ({
    sel_soed: false,
    sel_unso: false,
    search_str: '',
    dev_no: '',
    dlgStockOut: false,
    selected: [],
    mStartDate: false,
    mEndDate: false,
    dStart: '',
    dEnd: '',
    mDate: false,
    dlgEdit: false,
    dlgAEdit: false,
    dlgTitle: '',
    edID: 0,
    edItem: {
      kind: '',
      pn_d: 0,
      pn_date: 0,
      pn_week: 0,
      pd_no: 0,
      f_id: 0,
      pn_num: 0,
      batch_no: '',
      fm_no: 1,
      pd_date: 0,
      note: ''
    },
    headers: [
      { text: '日期', value: 'pn_d', sortable: false },
      { text: '序号', value: 'pd_no', sortable: false },
      { text: '客户', value: 'customer_title', sortable: false },
      { text: '釜票', value: 'formula', sortable: false },
      { text: '批次号', value: 'batch_no', sortable: false },
      { text: '釜数', value: 'pn_num', sortable: false },
      { text: '实际生产重量', value: 'pd_weight', sortable: false },
      { text: '打包数', value: 'pkg_num', sortable: false },
      { text: '已出库', value: 'so_weight', sortable: false },
      { text: '备注', value: 'note', sortable: false },
      { text: '操作', value: 'act', sortable: false }
    ],
    soHeaders: [
      { text: '序号', value: 'idx', sortable: false },
      { text: '品名及规格', value: 'name', sortable: false },
      { text: '单位', value: 'unit', sortable: false },
      { text: '仓储笼', value: 'cages', sortable: false },
      { text: '数量', value: 'weight', sortable: false },
      { text: '批次号', value: 'batch_no', sortable: false },
      { text: '箱数', value: 'pkg_num', sortable: false },
      { text: '备注', value: 'note', sortable: false }
    ],
    soData: {
      soNo: '',
      customer_name: '',
      customer_address: '',
      customer_contact: '',
      customer_phone: '',
      date: '2018-12-20'
    },
    soItems: [],
    produces: [],
    pagination: {
      page: 1,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    loading: false,
    intro: '',
    kinditems: [],
    canOut: true
  }),
  methods: {
    findSoItem(pdId) {
      for (var i = 0; i < this.soItems.length; ++i) {
        if (this.soItems[i].pd_id === pdId) return i
      }
      return -1
    },
    saveSo(type, pdId) {
      var i = this.findSoItem(pdId)
      if (i < 0) {
        MsgError('该id不存在')
        return
      }
      var e = this.soItems[i]
      if (type === 'weight') {
        if (parseFloat(e.weight) > parseFloat(e.u_weight)) {
          setTimeout(() => {
            e.weight = e.u_weight
          }, 100)
          MsgError('出库数量不能超过库存数量')
          return
        }
        e.pkg_n = Math.ceil(e.pkg_num * e.weight / e.pd_weight)
        this.updateSoNote(this.soItems[i])
      } else if (type === 'pkg_n') {
        this.updateSoNote(this.soItems[i])
      } else if (type === 'cages') {
        e.cages_s = e.cages_sel.join()
        e.weight = 0
        for (var k = 0; k < e.cages_sel.length; ++k) {
          var cageNo = e.cages_sel[i]
          for (var j = 0; j < e.cages.length; ++j) {
            if (e.cages[j] === cageNo) {
              e.weight += e.cages_w[j]
            }
          }
        }
        if (parseFloat(e.weight) > parseFloat(e.u_weight)) {
          setTimeout(() => {
            e.weight = e.u_weight
          }, 100)
          MsgError('出库数量不能超过库存数量')
          return
        }
        e.pkg_n = Math.ceil(e.pkg_num * e.weight / e.pd_weight)
        this.updateSoNote(this.soItems[i])
      }
    },
    updateSoNote(e) {
      Vue.set(e, 'note', e.pkg_n + ' × ' + e.formula_pkg_spec + '  (仓储笼:' + e.cages_s + ')')
    },
    doSo() {
      addStockOut(Date2Int(this.soData.date), this.soData.customer_id, this.soItems).then(res => {
        this.dlgStockOut = false
        this.reload()
      })
    },
    StockOut() {
      this.soItems = []
      var customerId = 0
      for (var i = 0; i < this.selected.length; ++i) {
        let e = this.selected[i]
        if (customerId === 0) {
          customerId = e.customer_id
          Vue.set(this.soData, 'soNo', '12345')
          Vue.set(this.soData, 'customer_id', e.customer_id)
          Vue.set(this.soData, 'customer_name', e.customer_title)
          Vue.set(this.soData, 'customer_address', e.customer_address)
          Vue.set(this.soData, 'customer_contact', e.customer_contact)
          Vue.set(this.soData, 'customer_phone', e.customer_phone)
          Vue.set(this.soData, 'date', Date2Str(new Date()))
        } else if (customerId !== e.customer_id) {
          MsgError('不是同一个客户的产品，不能在一个出库单上')
          this.soItems = []
          return
        }
        var o = Object()
        o['pd_id'] = e.id
        o['no'] = e.pd_no
        o['name'] = e.formula_code + ' - ' + e.formula_name + ' - ' + e.formula_color
        o['unit'] = 'kg'
        o['weight'] = (e.pd_weight - e.so_weight).toFixed(2)
        o['pkg_n'] = Math.ceil(e.pkg_num * o['weight'] / e.pd_weight)
        o['pd_weight'] = e.pd_weight
        o['so_weight'] = e.so_weight
        o['u_weight'] = o['weight']
        o['pkg_num'] = e.pkg_num
        o['batch_no'] = e.batch_no
        o['formula_pkg_spec'] = e.formula_pkg_spec
        o['cage_num'] = e.cage_num
        o['cages'] = []
        o['cages_w'] = []
        var ss = e.cages.split(',')
        for (var k = 0; k < ss.length; ++k) {
          var ff = ss[k].split(':')
          o['cages'].push(ff[0])
          o['cages_w'].push(parseFloat(ff[1]))
        }
        if (e.cages_out !== undefined && e.cages_out !== '') {
          o['cages_out'] = e.cages_out.split(',')
        } else {
          o['cages_out'] = []
        }
        o['cages_out'].forEach(e => {
          for (var k = 0; k < o['cages'].length; ++k) {
            if (o['cages'][k] === e) {
              o['cages'].splice(k, 1)
              o['cages_w'].splice(k, 1)
              break
            }
          }
        })
        o['cages_sel'] = o['cages']
        o['cages_s'] = o['cages_sel'].join(',')
        this.soItems.push(o)
        this.updateSoNote(o)
      }
      var d = Date2Int(new Date())
      getNewNo(d).then(res => {
        this.soData.soNo = ('' + d + res.data.no.toString().padStart(3, '0')).substr(2)
      })
      this.dlgStockOut = true
    },
    pdChange() {
      let n = parseFloat(this.edItem.pn_num)
      let ww = n * this.$refs.formulaSel.weight
      let tt = n * this.$refs.formulaSel.pd_time
      let fno = parseInt(this.edItem.fm_no);
      var fnos = '';
      if (!isNaN(fno)) {
        fnos = '釜号:' + fno + ' - ' + (fno + n - 1) + ',';
      }

      this.intro = fnos + '合计重量: ' + ww.toFixed(2) + 'kg,  所需时间: ' + Min2Str(parseInt(tt))
    },
    defaultItem() {
      this.edItem.kind = ''
      this.edItem.pn_date = 0
      this.edItem.pn_week = 0
      this.edItem.pd_no = 1
      this.edItem.f_id = 0
      this.edItem.pn_num = 0
      this.edItem.cage_no = 0
      this.edItem.note = ''
    },
    updItem() {
      var d = new Date()
      if (this.edItem.pn_date > 0) {
        d = new Date(Int2Date(this.edItem.pn_date))
      }
      this.edItem.pn_d = Date2Str(d)
      this.edItem.pn_week = d.getDay()
    },
    addItem() {
      this.edID = 0
      this.dlgTitle = '添加生产计划'
      this.defaultItem()
      this.updItem()
      this.dateChange()
      this.$refs.formulaSel.setVal(0, '')
    },
    editItem(item) {
      this.dlgEdit = true
      this.edID = item.id
      this.dlgTitle = '修改生产计划'
      this.edItem = Object.assign({}, item)
      this.updItem()
      this.$nextTick(() => {
        this.$refs.formulaSel.setVal(item.f_id, item.formula_code + ' - ' + item.formula_name)
      })
    },
    editItemA(item) {
      this.edID = item.id
      this.dlgTitle = '实际生产'
      this.dlgAEdit = true
      this.$nextTick(() => {
        this.$refs.produceA.setData(item)
      })
    },
    doDele(id) {
      deleteProduce(id).then(res => {
        this.reload()
      })
    },
    deleItem(item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要删除码?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDele(item.id);
        }
      })
    },
    cancel() {
      this.dlgEdit = false
    },
    cancelA() {
      this.dlgAEdit = false
    },
    save() {
      let d = new Date(this.edItem.pn_d)
      this.edItem.pn_date = Date2Int(d)
      this.edItem.pn_week = d.getDay()
      this.edItem.f_id = this.$refs.formulaSel.getVal()
      if (this.edID > 0) {
        modifyProduce(this.edID, this.edItem.kind, this.edItem.pd_no,
          this.edItem.pn_date, this.edItem.pn_week, this.edItem.f_id,
          this.edItem.pn_num, this.edItem.batch_no, this.edItem.fm_no,
          this.edItem.note).then(res => {
            this.reload()
            this.cancel()
          })
      } else {
        addProduce(this.edItem.kind, this.edItem.pd_no, this.edItem.pn_date,
          this.edItem.pn_week, this.edItem.f_id, this.edItem.pn_num,
          this.edItem.batch_no, this.edItem.fm_no,
          this.edItem.note).then(res => {
            this.reload()
            this.cancel()
          }).catch(() => {
            this.dlgEdit = true
          })
      }
    },
    saveA() {
      if (this.edID > 0) {
        this.$refs.produceA.submit().then(res => {
          this.reload()
          this.dlgAEdit = false
        })
      }
    },
    reload() {
      let d = {
        'soed': this.sel_soed ? 1 : 0,
        'unso': this.sel_unso ? 1 : 0,
        'start': Date2Int(this.dStart),
        'end': Date2Int(this.dEnd),
        'kw': this.search_str,
        'devno': this.dev_no,
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      this.loading = true
      getProduceList(d).then(res => {
        this.produces = res.data.items
        this.produces.forEach(e => {
          e.selected = false
          e.pn_d = Date2Str(e.pn_date) + ' (' + WeekStr(e.pn_week) + ')'
          e.formula = e.formula_code + ' - ' + e.formula_name
          e.pd_d = Date2Str(e.pd_date)
        })
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
        this.loading = false
      })
    },
    toexcel() {
      let d = {
        'soed': this.sel_soed ? 1 : 0,
        'unso': this.sel_unso ? 1 : 0,
        'start': Date2Int(this.dStart),
        'end': Date2Int(this.dEnd),
        'kw': this.search_str,
        'devno': this.dev_no
      }

      getProduceExcel(d).then((res) => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.setAttribute('download', '生产记录表.xlsx')
        link.click()
        window.URL.revokeObjectURL(objectUrl)
      })
    },
    toexcel1() {
      let start = Date2Int(this.dStart)
      let end = Date2Int(this.dEnd)
      let kw = this.search_str === undefined ? '' : this.search_str
      let devno = this.dev_no === undefined ? '' : this.dev_no;
      let token = Cookies.get(TOKEN_KEY)
      var w = window.open('', '_blank')
      let url = baseURLAPI + 'produce/toexcel'
      w.document.write(`<html><head>
                          <script>
                            function ff() {
                              this.form.submit();
                            }
                          <\/script>
                        </head><body>
                        <form name="form" method="post" action="` + url + `">
        <input type="hidden" name="start" value="` + start + `" />
        <input type="hidden" name="end" value="` + end + `" />
        <input type="hidden" name="devno" value="` + devno + `" />
        <input type="hidden" name="kw" value="` + kw + `" />
        <input type="hidden" name="token" value="` + token + `" />
        </form></body></html>`
      )
      w.ff()
    },
    dateChange() {
      this.mDate = false
      let d = Date2Int(this.edItem.pn_d)
      maxNo(d).then(res => {
        if (res.data.no) {
          this.edItem.pd_no = res.data.no + 1
        } else {
          this.edItem.pd_no = 1
        }
      })
    },
    loadKinds() {
      getKindList().then(res => {
        this.kinditems = res.data
      })
    }
  },
  computed: {
    canAddP() {
      return canDo(['admin', 'add_produce'], this.$store.state.user.access)
    },
    canActP() {
      return canDo(['admin', 'pd_produce'], this.$store.state.user.access)
    },
    canDelP() {
      return canDo(['admin', 'del_produce'], this.$store.state.user.access)
    },
    canSo() {
      return canDo(['admin', 'stockout'], this.$store.state.user.access)
    }
  },
  watch: {
    pagination: {
      handler() {
        this.reload()
      },
      deep: true
    },
    sel_soed() {
      if (this.sel_soed) this.sel_unso = false
    },
    sel_unso() {
      if (this.sel_unso) this.sel_soed = false
    },
    selected() {
      if (!this.canSo) return
      for (var i = 0; i < this.selected.length; ++i) {
        if (this.selected[i]) {
          this.canOut = false
          return
        }
      }
      this.canOut = true
    }
  },
  mounted() {
    this.reload()
    this.loadKinds()
  }
}
</script>
